<template>
  <div class="col-12 mt-5">

    <div class="row" v-for="(mandData, index) in mandDataset">
      <div :class="{
          'col-md-9' : (mandType != 6 && mandType != 10 && mandType != 8 && mandType != 7 && mandType != 11),
          'col-md-12' : !(mandType != 6 && mandType != 10 && mandType != 8 && mandType != 7 && mandType != 11)}">

        <div class="position-relative">
          <loader class="table-loader" v-if="isChangeStimuli"></loader>

          <line-chart class="row mt-2" v-bind:datasets="fetchDatasetForMandChart(mandData)"
                      :chart-id="'mandChart' + mandType + index"
                      :stageInfo="mandData.stageInfo"
                      :withoutMax="mandType == 5  || mandType == 8 || mandType == 10 || mandType == 11"
                      :persentMax="mandType != 5  && mandType != 6 && mandType != 8 && mandType != 11 && mandType != 10"
                      :is-value-type=true
                      v-bind:show-legend="mandType == 7 || mandType == 8"
                      v-bind:linedatasets="trendLinePoint[index]"
                      v-bind:y-axes-begin-at-zero="true"
                      v-bind:list-chart-date="mandData.days"
                      v-bind:vertical-line-point="mandData.pointArray"
                      :many-chart="mandType == 8 || mandType == 7"
                      v-bind:scale-label=scaleLabelTitle(mandType)
                      v-on:popup-show="popupShow"
                      :aspect-ratio=false
                      :height="280"
                      :width=null
                      v-if="mandType != 6 && mandType != 11"
          />

          <line-non-numeric-y-chart class="row mt-2" v-bind:datasets="fetchDatasetForMandChart(mandData)"
                                    :chart-id="'mandChart' + mandType + index"
                                    :stageInfo="mandData.stageInfo"
                                    v-bind:y-labels="hintRezultsLevels"
                                    v-bind:show-legend="false"
                                    v-bind:y-axes-begin-at-zero="true"
                                    v-on:popup-show="popupShow"
                                    v-bind:scale-label=scaleLabelTitle(mandType)
                                    :height="280"
                                    :width=null
                                    :aspect-ratio=false
                                    v-if="mandType == 6 && mandLevels.length && fetchDatasetForMandChart(mandData).length"
          />

          <h4 class="chart__title mb-3" v-if="(mandType != 11 && mandType != 6) || (mandType == 6 && mandLevels.length && fetchDatasetForMandChart(mandData).length)">
            {{mandGraphReactionTitle(mandType)}}: <span>{{mandTitle}}</span>. {{mandData.stageInfo.description}}.
            <br>
            <span  v-if="mandType == 3  || mandType == 7 || mandType == 8">
            {{ 'report.legend' | trans }}
            {{mandAnswers[0].title}} - {{mandAnswers[0].description}},
            {{mandAnswers[1].title}} - {{mandAnswers[1].description}},
            {{mandAnswers[4].title}} - {{mandAnswers[4].description}}.
          </span>
            <span  v-if="mandType == 9  || mandType == 10">
            {{ 'report.legend' | trans }}
            {{mandAnswers[2].title}} - {{mandAnswers[2].description}}
          </span>
          </h4>
        </div>

      </div>


      <div class="mt-3"   :class="{
          'col-md-3' : (mandType != 6 && mandType != 10 && mandType != 8 && mandType != 7 && mandType != 11)}"
           v-if="mandType != 6 && mandType != 10 && mandType != 8 && mandType != 7 && mandType != 11  && index == 0">

        <mdc-switch v-model="levelMandLineChecked">{{ 'protocol.levelLine' | trans }}</mdc-switch>
        <mdc-switch v-model="trendMandLineChecked">{{ 'protocol.trendLine' | trans }}</mdc-switch>
        <mdc-switch v-model="scatterMandLineChecked">{{ 'protocol.scatterLine' | trans }}</mdc-switch>
      </div>


    </div>

    <div v-if="isModalVisible">
      <mand-popup :visible="isModalVisible"
                  v-on:close="onClose"
                  :stimulName="mandTitle"
                  :mandType="mandType"
                  :mandId="mandId"
                  :typeTitle="stageInfo.description"
                  :graphTitle = "mandGraphReactionTitle(mandType)"
                  :protocolId="protocolId"
                  :mandAnswers="mandAnswers"
                  :stageId="stageInfo.id"
                  :dataPoint="dataPoint">
      </mand-popup>

    </div>



  </div>


</template>

<script>
  import Loader from '../../loader/components/Loader';
  import {LineNonNumericYChart, LineChart, LineChartDataset} from '../../../common/chart';
  import forEach from 'lodash/forEach';
  import lang from '../../../lang/translator';
  import filter from 'lodash/filter';
  import findIndex from 'lodash/findIndex';
  import minBy from 'lodash/minBy';
  import maxBy from 'lodash/maxBy';
  import toInteger from 'lodash/toInteger';
  import findKey from 'lodash/findKey';
  import TableView from '../../../common/table/components/TableView';
  import map from 'lodash/map';
  import repeat from 'lodash/repeat';
  import cloneDeep from 'lodash/cloneDeep';
  import drop from 'lodash/drop';
  import round from 'lodash/round';
  import moment from 'moment';
  import values from 'lodash/values';
  import mandPopup from './MandPopup';
  import Constants from '../../undesirableBehavior/Constants';


  export default {
    props: ['mandDataset', 'mandType', 'mandChanges', 'mandLevels', 'mandAnswers', 'mandTitle', 'protocolId', 'mandId', 'clientData'],
    components: {
      mandPopup,
      LineChart, LineNonNumericYChart, Loader},

    data() {
      return {
        listMandChartDate: [],
        hintRezultsLevels: [],
        verticalLineMandPoint: [],
        mandGraphReaction: null,
        levelMandLineChecked: false,
        trendMandLineChecked: false,
        scatterMandLineChecked: false,
        trendMandLinePoint: false,
        datasetForMandChart: [],
        trendLinePoint: [],
        isChangeStimuli: false,
        isModalVisible: false,
        dataPoint: null,
        stageInfo: null
      };
    },

    computed: {

    },

    async created() {
      this.hintRezultsLevels = map(this.mandLevels, hint => {return hint.description});
    },

    methods: {
      mandGraphReactionTitle(type){

        let typeTitle = toInteger(type)
        switch (typeTitle) {
          case 1:
            return lang.get('report.graph_mo_yes_percent');
            break;
          case 2:
            return lang.get('report.graph_mo_yes');
            break;
          case 3:
            return lang.get('report.graph_probe', {
              'first': this.mandAnswers[0].title,
              'second': this.mandAnswers[1].title,
              'third': this.mandAnswers[4].title,
            });
            break;
          case 4:
            return lang.get('report.graph_mo_goal');
            break;
          case 5:
            return lang.get('report.graph_mand_react', {
              'first': this.mandAnswers[0].title,
              'second': this.mandAnswers[1].title,
              'third': this.mandAnswers[4].title,
            });
            break;
          case 6:
            return lang.get('report.graph_prompt_levels');
            break;
          case 7:
            return lang.get('report.graph_goal', {
              'first': this.mandAnswers[0].title,
              'second': this.mandAnswers[1].title,
              'third': this.mandAnswers[4].title,
            });
            break;
          case 8:
            return lang.get('report.graph_cumulative_improve', {
              'first': this.mandAnswers[0].title,
              'second': this.mandAnswers[1].title,
              'third': this.mandAnswers[4].title,
            });
            break;
          case 9:
            return lang.get('report.graph_improve_prompt', {
              'improve': this.mandAnswers[2].title
            });
            break;
          case 10:
            return lang.get('report.graph_improve', {
              'improve': this.mandAnswers[2].title
            });
            break;
          case 11:
            return lang.get('report.graph_relation_prompt', {
              'plus': '+',
              'second': this.mandAnswers[1].title,
            });
            break;

        }
      },

      popupShow(data,stageInfo){

        if(this.mandType != 5 && this.mandType != 8 && this.mandType != 10 && this.mandType != 11){

          this.dataPoint = moment.utc(data.x, 'DD.MM.YYYY').unix();
          this.stageInfo = stageInfo;
          this.isModalVisible = true;
        }
      },

      onClose() {
        this.isModalVisible = false;
      },

      scaleLabelTitle(type){

        let typeTitle = toInteger(type)
        switch (typeTitle) {
          case 1:
            return lang.get('report.label_mo_yes_percent');
            break;
          case 2:
            return lang.get('report.label_mo_yes');
            break;
          case 3:
            return lang.get('report.label_probe', {
              'first': this.mandAnswers[0].title,
              'second': this.mandAnswers[1].title,
              'third': this.mandAnswers[4].title,
            });
            break;
          case 4:
            return lang.get('report.label_mo_goal');
            break;
          case 5:
            return lang.get('report.label_mand_react', {
              'first': this.mandAnswers[0].title,
              'second': this.mandAnswers[1].title,
              'third': this.mandAnswers[4].title,
            });
            break;
          case 6:
            return lang.get('report.label_prompt_levels');
            break;
          case 7:
            return lang.get('report.label_goal', {
              'first': this.mandAnswers[0].title,
              'second': this.mandAnswers[1].title,
              'third': this.mandAnswers[4].title,
            });
            break;
          case 8:
            return lang.get('report.label_cumulative_improve', {
              'first': this.mandAnswers[0].title,
              'second': this.mandAnswers[1].title,
              'third': this.mandAnswers[4].title,
            });
            break;
          case 9:
            return lang.get('report.label_improve_prompt', {
              'improve': this.mandAnswers[2].title
            });
            break;
          case 10:
            return lang.get('report.label_improve', {
              'improve': this.mandAnswers[2].title
            });
            break;
          case 11:
            return lang.get('report.label_relation_prompt', {
              'plus': '+',
              'second': this.mandAnswers[1].title,
            });
            break;

        }
      },

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
      },

      trendLine(item) {
        let SumOfPowX = 0, SumOfX = 0, n = item.length, SumOfXY = 0, SumOfY = 0;

        for(let i = 0; i < n; i++)
        {
          SumOfPowX += (i+1) * (i+1);
          SumOfX += (i+1);
          SumOfXY += (i+1) * item[i].y;
          SumOfY += item[i].y;
        }
        let det = SumOfPowX * n - Math.pow(SumOfX, 2);
        let a = (SumOfXY * n - SumOfX * SumOfY) / det;
        let b = (SumOfY - a * SumOfX) / n;

        let first = a + b;
        let last = a*n + b;

        let data = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: first,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n-1].x,
            y: last,
          },
        ];

        let dataset = new LineChartDataset({
          data,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        return dataset

      },

      levelLine(item) {
        let n = item.length, SumOfY = 0, y = 0;

        forEach(item, point => {
          SumOfY += point.y;
        });

        y = SumOfY/n;

        let data = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: y,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n-1].x,
            y: y,
          },
        ];

        let dataset = new LineChartDataset({
          data,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        return dataset

      },

      scatterLine(item) {
        let n = item.length, SumOfY = 0, y = 0;

        let min = minBy(item, function(o) {
          return o.y;
        });
        let max = maxBy(item, function(o) {
          return o.y;
        });



        let dataMin = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: min,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n-1].x,
            y: min,
          },
        ];

        let dataMax = [
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[0].x,
            y: max,
          },
          {
            comment: "",
            isChanged: false,
            isImportant: false,
            x: item[n-1].x,
            y: max,
          },
        ];

        let datasetMin = new LineChartDataset({
          data: dataMin,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        let datasetMax = new LineChartDataset({
          data: dataMax,
          borderColor: '#000',
          pointBorderWidth: 1,
          pointHoverRadius: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          borderWidth: 1
        });

        let dataset = [datasetMin, datasetMax]

        return dataset

      },

      fetchDatasetForMandChart(mandDataset){

        let datasetForMand = mandDataset.values;
        let datasetForMandHint = cloneDeep(mandDataset.hintResultsData);
        let datasetForMandType = cloneDeep(this.mandType);

        let data = [], i = 0, datasetMandChart = [], promptList = {};

        if (datasetForMandType != 7 && datasetForMandType != 8 && datasetForMandType != 6){

          let chart = new LineChartDataset({
            data: datasetForMand,
            label: datasetForMandType
          });

          if (this.trendMandLineChecked || this.levelMandLineChecked || this.scatterMandLineChecked){
            forEach(this.mandDataset, (dataSet, key) => {
              this.trendLinePoint[key] = this.fetchDatasetLineTrend(dataSet.values, this.trendMandLineChecked, this.levelMandLineChecked, this.scatterMandLineChecked);
            });
          } else{
            forEach(this.mandDataset, (dataSet, key) => {
              this.trendLinePoint[key] = null;
            });
          }


          datasetMandChart = [chart];
        }

        if (datasetForMandType == 7 || datasetForMandType == 8){
          let spontaneous = [],himself = [], prompts = [];

          forEach(datasetForMand, (day, index) => {

            spontaneous.push(day.spontaneous);
            himself.push(day.himself);
            prompts.push(day.prompts)

          });

          let datasetSpontaneous = new LineChartDataset({
            data: spontaneous,
            label: this.mandAnswers[0].title,
            pointStyle: 'rect'
          });
          let datasetHimselfs = new LineChartDataset({
            data: himself,
            label: this.mandAnswers[1].title,
            pointStyle: 'circle'
          });
          let datasetPrompts = new LineChartDataset({
            data: prompts,
            label: this.mandAnswers[4].title,
            pointStyle: 'rectRot'
          });

          datasetMandChart = [datasetSpontaneous, datasetHimselfs, datasetPrompts]
        }

        if (datasetForMandType == 6){
          forEach (datasetForMandHint, (dataItem) => {

            let dateChart = values(dataItem.data);

            if(dateChart.length){
              datasetMandChart.push(new LineChartDataset({
                data: dateChart,
              }))
            }


          });

        }

        this.datasetForMandChart = datasetMandChart;

        return datasetMandChart;

      },

      fetchDatasetLineTrend(item, trendLine, levelLine, scatterLine) {
        let data = [], trendPointIndex = [],trendPoint = [], i = 0;
        let array = [];

        forEach(item, (point, index) => {

          if (point.isImportant){
            trendPoint.push(
                array
            );
            array = [];
            trendPointIndex.push(index)
          } else{
            if (!point.isChanged) {
              array.push(point);
            }
            if (index == item.length - 1){
              trendPoint.push(
                  array
              );
            }
          }

        });

        let dataset = [];

        if (trendLine){
          forEach(trendPoint, (point) => {
            if (point.length > 2){
              dataset.push(this.trendLine(point));
            }
          });
        }
        if (levelLine){
          forEach(trendPoint, (point) => {
            if (point.length > 2) {
              dataset.push(this.levelLine(point));
            }
          });
        }
        if(scatterLine){
          forEach(trendPoint, (point) => {
            if (point.length > 2) {
              dataset.push(this.scatterLine(point)[0]);
              dataset.push(this.scatterLine(point)[1]);
            }
          });
        }

        return dataset
      },
    },
    watch: {
      levelMandLineChecked(newValue) {
        this.isChangeStimuli = true;
        if (this.trendMandLineChecked || this.levelMandLineChecked || this.scatterMandLineChecked){
          forEach(this.mandDataset, (dataSet, key) => {
            this.trendLinePoint[key] = this.fetchDatasetLineTrend(dataSet.values, this.trendMandLineChecked, this.levelMandLineChecked, this.scatterMandLineChecked);
          });
        } else{
          forEach(this.mandDataset, (dataSet, key) => {
            this.trendLinePoint[key] = null;
          });
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);

      },
      trendMandLineChecked(newValue) {
        this.isChangeStimuli = true;
        if (this.trendMandLineChecked || this.levelMandLineChecked || this.scatterMandLineChecked){
          forEach(this.mandDataset, (dataSet, key) => {
            this.trendLinePoint[key] = this.fetchDatasetLineTrend(dataSet.values, this.trendMandLineChecked, this.levelMandLineChecked, this.scatterMandLineChecked);
          });
        } else{
          forEach(this.mandDataset, (dataSet, key) => {
            this.trendLinePoint[key] = null;
          });
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);

      },
      scatterMandLineChecked(newValue) {
        this.isChangeStimuli = true;
        if (this.trendMandLineChecked || this.levelMandLineChecked || this.scatterMandLineChecked){
          forEach(this.mandDataset, (dataSet, key) => {
            this.trendLinePoint[key] = this.fetchDatasetLineTrend(dataSet.values, this.trendMandLineChecked, this.levelMandLineChecked, this.scatterMandLineChecked);
          });
        } else{
          forEach(this.mandDataset, (dataSet, key) => {
            this.trendLinePoint[key] = null;
          });
        }
        setTimeout(() => {
          this.isChangeStimuli = false;
        }, 500);

      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/CurrentStageMand.vue